<template>
  <div class="task_detail_dialog">
    <div class="content my_task_item">
      <!-- neirong {{ taskInfo.id }}----{{ taskInfo.title }} -->
      <span class="right_top">公司</span>
      <div class="task_board">
        <div class="task_name">{{taskInfo.followUpTaskName}}</div>
        <div class="followup">
          <span>ID：{{taskInfo.followUpTaskId}}</span>
          <span>结束时间：{{ taskInfo.taskEndTime }}</span>
          <el-button type="primary" size="mini" @click="startFollowup" :disabled="!taskInfo.isFollowup">开始随访</el-button>
        </div>
        <!-- 主要数据 -->
        <div class="data_table">
          <div class="followup_data_header">
            <span>&nbsp;</span>
            <span>人均（1个月）</span>
            <span>我的（1个月）</span>
            <span>所有人</span>
          </div>
          <div class="followup_data">
            <div class="followup_data_col table_label">
              <span>成功</span>
              <span>未成功</span>
              <span>失访</span>
              <span>稍后拨打</span>
              <span>异常随访</span>
              <span>有效通话时长中位数</span>
              <span>平均通话时长</span>
              <span>当前质控</span>
              <span>质控合格率</span>
            </div>
            <div class="followup_data_col">
              <span>&nbsp;{{resultTaskInfo.avgTaskFollowupData.successNumber}}</span>
              <span>&nbsp;{{resultTaskInfo.avgTaskFollowupData.refuseNumber}}</span>
              <span>&nbsp;{{resultTaskInfo.avgTaskFollowupData.loseNumber}}</span>
              <span>&nbsp;{{resultTaskInfo.avgTaskFollowupData.laterNumber}}</span>
              <span>&nbsp;{{resultTaskInfo.avgTaskFollowupData.exceptionNumber}}</span>
              <span>&nbsp;{{resultTaskInfo.avgTaskFollowupData.validTalkTimeMedianHandle}}</span>
              <span>&nbsp;{{resultTaskInfo.avgTaskFollowupData.avgCompleteValidTimeHandle}}</span>
              <span>&nbsp;{{resultTaskInfo.avgTaskFollowupData.qualityPersonNumber}}</span>
              <span>&nbsp;{{resultTaskInfo.avgTaskFollowupData.qualifiedRate || '0%'}}</span>
            </div>
            <div class="followup_data_col">
              <span>
                &nbsp;{{resultTaskInfo.myTaskFollowupData.successNumber}}({{resultTaskInfo.myTaskFollowupData.successRate}})
                <i v-if="resultTaskInfo.myTaskFollowupData.successNumber>resultTaskInfo.avgTaskFollowupData.successNumber" style="color: #F21702;" class="el-icon-top"></i>
                <i v-if="resultTaskInfo.myTaskFollowupData.successNumber<resultTaskInfo.avgTaskFollowupData.successNumber" style="color: #A2EF4D;" class="el-icon-bottom"></i>
              </span>
              <span>
                &nbsp;{{resultTaskInfo.myTaskFollowupData.refuseNumber}}({{resultTaskInfo.myTaskFollowupData.refuseRate}})
                <i v-if="resultTaskInfo.myTaskFollowupData.refuseNumber>resultTaskInfo.avgTaskFollowupData.refuseNumber" style="color: #F21702;" class="el-icon-top"></i>
                <i v-if="resultTaskInfo.myTaskFollowupData.refuseNumber<resultTaskInfo.avgTaskFollowupData.refuseNumber" style="color: #A2EF4D;" class="el-icon-bottom"></i>
              </span>
              <span>
                &nbsp;{{resultTaskInfo.myTaskFollowupData.loseNumber}}({{resultTaskInfo.myTaskFollowupData.loseRate}})
                <i v-if="resultTaskInfo.myTaskFollowupData.loseNumber>resultTaskInfo.avgTaskFollowupData.loseNumber" style="color: #F21702;" class="el-icon-top"></i>
                <i v-if="resultTaskInfo.myTaskFollowupData.loseNumber<resultTaskInfo.avgTaskFollowupData.loseNumber" style="color: #A2EF4D;" class="el-icon-bottom"></i>
              </span>
              <span>
                &nbsp;{{resultTaskInfo.myTaskFollowupData.laterNumber}}
                <i v-if="resultTaskInfo.myTaskFollowupData.laterNumber>resultTaskInfo.avgTaskFollowupData.laterNumber" style="color: #F21702;" class="el-icon-top"></i>
                <i v-if="resultTaskInfo.myTaskFollowupData.laterNumber<resultTaskInfo.avgTaskFollowupData.laterNumber" style="color: #A2EF4D;" class="el-icon-bottom"></i>
              </span>
              <span>
                &nbsp;{{resultTaskInfo.myTaskFollowupData.exceptionNumber}}
                <i v-if="resultTaskInfo.myTaskFollowupData.exceptionNumber>resultTaskInfo.avgTaskFollowupData.exceptionNumber" style="color: #F21702;" class="el-icon-top"></i>
                <i v-if="resultTaskInfo.myTaskFollowupData.exceptionNumber<resultTaskInfo.avgTaskFollowupData.exceptionNumber" style="color: #A2EF4D;" class="el-icon-bottom"></i>
              </span>
              <span>
                &nbsp;{{resultTaskInfo.myTaskFollowupData.validTalkTimeMedianHandle}}
                <i v-if="resultTaskInfo.myTaskFollowupData.validTalkTimeMedian*1>resultTaskInfo.avgTaskFollowupData.validTalkTimeMedian*1" style="color: #F21702;" class="el-icon-top"></i>
                <i v-if="resultTaskInfo.myTaskFollowupData.validTalkTimeMedian*1<resultTaskInfo.avgTaskFollowupData.validTalkTimeMedian*1" style="color: #A2EF4D;" class="el-icon-bottom"></i>
              </span>
              <span>
                &nbsp;{{resultTaskInfo.myTaskFollowupData.avgCompleteValidTimeHandle}}
                <i v-if="resultTaskInfo.myTaskFollowupData.avgCompleteValidTime*1 > resultTaskInfo.avgTaskFollowupData.avgCompleteValidTime*1" style="color: #F21702;" class="el-icon-top"></i>
                <i v-if="resultTaskInfo.myTaskFollowupData.avgCompleteValidTime*1 < resultTaskInfo.avgTaskFollowupData.avgCompleteValidTime*1" style="color: #A2EF4D;" class="el-icon-bottom"></i>
              </span>
              <span>
                &nbsp;{{resultTaskInfo.myTaskFollowupData.qualityPersonNumber}}
                <i v-if="resultTaskInfo.myTaskFollowupData.qualityPersonNumber>resultTaskInfo.avgTaskFollowupData.qualityPersonNumber" style="color: #F21702;" class="el-icon-top"></i>
                <i v-if="resultTaskInfo.myTaskFollowupData.qualityPersonNumber<resultTaskInfo.avgTaskFollowupData.qualityPersonNumber" style="color: #A2EF4D;" class="el-icon-bottom"></i>
              </span>
              <span>
                &nbsp;{{resultTaskInfo.myTaskFollowupData.qualifiedRate || '0%'}}
                <i v-if="resultTaskInfo.myTaskFollowupData.qualifiedRateNum>resultTaskInfo.avgTaskFollowupData.qualifiedRateNum" style="color: #F21702;" class="el-icon-top"></i>
                <i v-if="resultTaskInfo.myTaskFollowupData.qualifiedRateNum<resultTaskInfo.avgTaskFollowupData.qualifiedRateNum" style="color: #A2EF4D;" class="el-icon-bottom"></i>
              </span>
            </div>
            <div  class="followup_data_col">
              <span>&nbsp;{{resultTaskInfo.allTaskFollowupData.successNumber}}({{resultTaskInfo.allTaskFollowupData.successRate}})</span>
              <span>&nbsp;{{resultTaskInfo.allTaskFollowupData.refuseNumber}}({{resultTaskInfo.allTaskFollowupData.refuseRate}})</span>
              <span>&nbsp;{{resultTaskInfo.allTaskFollowupData.loseNumber}}({{resultTaskInfo.allTaskFollowupData.loseRate}})</span>
              <span>&nbsp;{{resultTaskInfo.allTaskFollowupData.laterNumber}}</span>
              <span>&nbsp;{{resultTaskInfo.allTaskFollowupData.exceptionNumber}}</span>
              <span>&nbsp;{{resultTaskInfo.allTaskFollowupData.validTalkTimeMedianHandle}}</span>
              <span>&nbsp;{{resultTaskInfo.allTaskFollowupData.avgCompleteValidTimeHandle}}</span>
              <span>&nbsp;{{resultTaskInfo.allTaskFollowupData.qualityPersonNumber}}</span>
              <span>&nbsp;{{resultTaskInfo.allTaskFollowupData.qualifiedRate || '0%'}}</span>
            </div>

          </div>
        </div>
        
        <div class="task_pro_wait">
          <span>已随访：<span style="color: #4095E5;">{{ taskInfo.taskCompleteNumber }}</span></span>
          <span>待随访：<span style="color: #4095E5;">{{ taskInfo.taskWaitNumber }}</span></span>
        </div>
        <div class="task_progress">
            <el-progress :percentage="taskInfo.taskCompleteRateNum" 
              :text-inside="true" 
              :format="format"
              :stroke-width="16"
              text-color="#fff"
              ></el-progress>
          
          <div style="font-size: 14px;">总人数：{{taskInfo.taskTotalNumber}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from "vuex";

export default {
  props: ['taskInfo'],
  name: 'taskDetailDialog',
  data (){
    return {
      resultTaskInfo: this.taskInfo
    }
  },
  watch: {},
  mounted(){
    let vm = this
    vm.onLoad()
  },
  methods: {
    ...mapMutations([
      'setTaskTitle',
      'setTaskCenterId',
      'setQuestion'
    ]),
    format(percentage) {
      return `完成：${percentage}%`;
    },
    onLoad(){
      console.log('taskInfo',this.taskInfo);
      

    },
    startFollowup() {
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId',
          params: { followupTaskId: this.resultTaskInfo.followUpTaskId}
        }
      ).then(res => {
        if (res.status==0) {
          this.setQuestion(res.retValue);
        }
      })
      this.$router.push({
        path: "/taskDetail",
        query: {
          isOpen: this.resultTaskInfo.isOpen,
          diseaseId: this.resultTaskInfo.diseaseId,
          isFrontPage: 1,
          isRemindStudy: this.resultTaskInfo.isRemindStudy,
          isSingleDuration: this.resultTaskInfo.isSingleDuration,
          isTotalDuration: this.resultTaskInfo.isTotalDuration,
        },
      });
      this.setTaskTitle(this.resultTaskInfo.followUpTaskName);
      this.setTaskCenterId(this.resultTaskInfo.followUpTaskId);
      localStorage.setItem('isFrontPage', 1)
      localStorage.setItem('taskId',this.resultTaskInfo.followUpTaskId)
    },
  }
}
</script>

<style lang="scss" scoped>
.task_detail_dialog {
  .content {
    color: #000; 
  }
  .my_task_item {
    position: relative;
    .right_top{
      background: red;
      height: 22px;
      width: 40px;
      text-align: center;
      line-height: 22px;
      border-radius: 0 0 0 8px;
      font-size: 12px;
      position: absolute;
      top: 5px;
      right: 5px;
      color: #fff;
    }
  }
  .data_table {
    font-size: 15px;
    font-weight: bold;
    margin: 30px;
  }
  .task_board {
      // border: 1px solid rgba(0,0,0,.2);
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
      padding: 10px;
      font-size: 14px;
      margin: 5px;
      .task_name{
        font-weight: bold;
        font-size: 16px;
        margin-right: 40px;
      }
      .followup{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 8px 0;
        color: #999;
      }
      .task_pro_wait {
        margin: 0 20px;
        &>span {
          margin-right: 50px;
        }
      }
      .task_progress {
        margin-top: 15px;
        margin-bottom: 25px;
        padding-left: 20px;
        display: grid;
        grid-template-columns: 80% 20%;
        grid-gap: 10px;
      }
    }
    .followup_data_header {
      display: flex;
      &>span {
        width: 25%;
        margin-bottom: 8px;
        text-align: center;
      }
    }
    .followup_data {
      display: flex;
      .followup_data_col{
        width: 25%;
        display: flex;
        flex-direction: column;
        &>span {
          margin-bottom: 8px;
          text-align: center;
          color: #4095E5;
        }
      }
      .table_label>span{
        text-align: right;
        color: #000;
      }
    }
}
</style>
